import 'core-js/actual/array/filter';
import 'core-js/actual/array/find';
import 'core-js/actual/array/find-index';
import 'core-js/actual/array/includes';
import 'core-js/actual/array/map';
import 'core-js/actual/array/reduce';
import 'core-js/actual/array/some';
import 'core-js/actual/array/sort';
import 'core-js/actual/object/entries';
import 'core-js/actual/object/values';
import 'core-js/actual/promise';
import 'core-js/actual/url-search-params';
import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {withAuthentication} from './components/authentication/authentication-hoc';
import Menu from './components/menu/menu';
import Demo from './components/demo';
import Instructions from './components/instructions';
import InstructionsForShopifyPageOsV2 from './components/instructions/shopify-page-osv2/index';
import InstructionsForShopifyProductPageOsV2 from './components/instructions/shopify-product-page-osv2/index';
import InstructionsForShopifyCartPageOsV2 from './components/instructions/shopify-cart-page-osv2/index';
import AppBlocksTutorial from './components/instructions/tutorials/app-blocks';
import PassingDataTutorial from './components/instructions/tutorials/passing-data';
import Forms from './components/forms';
import FormEdit from './components/forms/form-edit';
import Submissions from './components/submissions';
import FormSubmissions from './components/submissions/form-submissions';
import Notifications from './components/notifications';
import SmtpConfigPage from './components/notifications/smtp-config-page';
import FormNotification from './components/notifications/form-notification';
import Dropbox from './components/integrations/dropbox';
import GoogleDrive from './components/integrations/google-drive';
import GoogleDriveAccount from './components/integrations/google-drive/account';
import GoogleSheets from './components/integrations/google-sheets';
import GoogleSheetsIntegration from './components/integrations/google-sheets/integration';
import Recaptcha from './components/integrations/recaptcha';
import RecaptchaKeyPair from './components/integrations/recaptcha/key-pair';
import ShopifyIntegrations from './components/integrations/shopify';
import SaveMetafieldsShopifyIntegration from './components/integrations/shopify/save-metafields';
import SaveCustomerShopifyIntegration from './components/integrations/shopify/save-customer';
import Zapier from './components/integrations/zapier/zapier';
import BillingSubscription from './components/billing/subscription';
import GetInTouch from './components/get-in-touch/get-in-touch';
import './App.scss';

const App = () => {

  const Container = ({children}) => <section className="container mt-4">
    {children}
  </section>;

  return <BrowserRouter>
    <div>
      <Menu/>
      <Routes>
        <Route exact path="/"
               element={<Container><Demo/></Container>}/>

        <Route exact path="/instructions"
               element={<Container><Instructions/></Container>}/>
        <Route exact path="/instructions/shopify-page-osv2"
               element={<Container><InstructionsForShopifyPageOsV2/></Container>}/>
        <Route exact path="/instructions/shopify-product-page-osv2"
               element={<Container><InstructionsForShopifyProductPageOsV2/></Container>}/>
        <Route exact path="/instructions/shopify-cart-page-osv2"
               element={<Container><InstructionsForShopifyCartPageOsV2/></Container>}/>
        <Route exact path="/instructions/tutorials/app-blocks"
               element={<Container><AppBlocksTutorial/></Container>}/>
        <Route exact path="/instructions/tutorials/passing-data"
               element={<Container><PassingDataTutorial/></Container>}/>

        <Route exact path="/forms" element={<Container><Forms/></Container>}/>
        <Route exact path="/forms/:formId" element={<Container><FormEdit/></Container>}/>
        <Route exact path="/forms/:formId/submissions" element={<Container><FormSubmissions/></Container>}/>
        <Route exact path="/forms/:formId/notifications/:notificationId"
               element={<Container><FormNotification/></Container>}/>

        <Route exact path="/submissions" element={<Container><Submissions/></Container>}/>

        <Route exact path="/notifications" element={<Container><Notifications/></Container>}/>
        <Route exact path="/smtp-configs/:id" element={<Container><SmtpConfigPage/></Container>}/>

        <Route exact path="/integrations/dropbox" element={<Container><Dropbox/></Container>}/>
        <Route exact path="/integrations/google-drive" element={<Container><GoogleDrive/></Container>}/>
        <Route exact path="/integrations/google-drive/accounts/:accountId" element={<Container><GoogleDriveAccount/></Container>}/>
        <Route exact path="/integrations/google-sheets" element={<Container><GoogleSheets/></Container>}/>
        <Route exact path="/integrations/google-sheets/:integrationId"
               element={<Container><GoogleSheetsIntegration/></Container>}/>
        <Route exact path="/integrations/recaptcha" element={<Container><Recaptcha/></Container>}/>
        <Route exact path="/integrations/recaptcha/:keyPairId" element={<Container><RecaptchaKeyPair/></Container>}/>
        <Route exact path="/integrations/shopify" element={<Container><ShopifyIntegrations/></Container>}/>
        <Route exact path="/integrations/shopify/save-metafields/:integrationId" element={<Container><SaveMetafieldsShopifyIntegration/></Container>}/>
        <Route exact path="/integrations/shopify/save-customer/:integrationId" element={<Container><SaveCustomerShopifyIntegration/></Container>}/>
        <Route exact path="/integrations/zapier" element={<Container><Zapier/></Container>}/>

        <Route exact path="/billing/plans" element={<Container><BillingSubscription/></Container>}/>
        <Route exact path="/get-in-touch" element={<Container><GetInTouch/></Container>}/>
      </Routes>
    </div>
  </BrowserRouter>;
};

export default withAuthentication(App);
